import React, { useState, useEffect } from 'react';
import { isEmpty, isNil } from 'ramda';
import { useSelector, useDispatch } from 'react-redux';
import { fetchProfileDataRequest } from 'stores/profileSettings/actions';
import SelectTopic from 'components/SelectTopic';
import Content from 'components/Content/Content';
import Overlay from 'components/Content/Overlay';
import Sidebar from 'components/Sidebar/Sidebar';
import SidebarLevels from 'components/Sidebar/SidebarLevels';
import SidebarTopics from 'components/Sidebar/SidebarTopics';
import './BrowseContent.styles.scss';
// import { Redirect } from 'react-router-dom';
import Header from 'components/Header/Header';

export default function BrowseContent() {
  const dispatch = useDispatch();
  // const { user } = useSelector(state => state.login);
  const { selectedTopic, showSideBar } = useSelector(state => state.topics);
  const { selectedCurriculum } = useSelector(state => state.curriculums);
  const { profileData, isLoading: isProfileLoading, error: profileError } = useSelector(
    state => state.profileSettings
  );
  const currLevels = selectedCurriculum && selectedCurriculum.Levels;
  const [expanded, setExpanded] = useState(false);
  const toggleNavigation = () => setExpanded(!expanded);

  // Ensure User/GetMyProfile API is completed
  useEffect(() => {
    // If profileData is empty or CountryId is missing, and not loading, and no error, trigger API
    if (
      !isProfileLoading &&
      !profileError &&
      (isEmpty(profileData) || isNil(profileData?.CountryId) || profileData?.CountryId === '')
    ) {
      dispatch(fetchProfileDataRequest());
    }
    // Note: curriculums loading will be automatically handled by watchProfileDataForCurriculums saga
    // It will automatically trigger when FETCH_PROFILE_DATA_SUCCESS, no need to manually trigger here
  }, [dispatch, profileData, isProfileLoading, profileError]);

  // if (
  //   (isNil(user.DefaultLevel) || user.DefaultLevel < 1) &&
  //   !isEmpty(currLevels)
  // ) {
  //   return <Redirect to="/choose-level" />;
  // }

  return (
    <>
      <Header />
      <main>
        <Sidebar expanded={expanded} toggleNavigation={toggleNavigation}>
          {!isEmpty(currLevels) && <SidebarLevels />}
          <SidebarTopics />
        </Sidebar>
        <div className="content content--browse-content">
          {isEmpty(selectedTopic) && !showSideBar ? (
            <>
              <Overlay isVisible={expanded} toggleVisible={toggleNavigation} />
              <SelectTopic textClass={expanded ? 'text-light' : ''} />
            </>
          ) : (
            <>
              <Content />
              <Overlay isVisible={expanded} toggleVisible={toggleNavigation} />
            </>
          )}
        </div>
      </main>
    </>
  );
}
